import React from 'react';
import { AdsContextProvider } from '@/contexts/ads-context';
import { CreateAccountScreen } from '@/screens/locations/create-account-screen';
import { createStackNavigator } from '@react-navigation/stack';
import { EditAccountScreen } from '@/screens/locations/edit-account-screen';
import { EmployeeDetailScreen } from '@/screens/restaurant/employee-detail-screen';
import { EmployeeNotificationsScreen } from '@/screens/restaurant/employee-notifications-screen';
import { ItemLeadTimeContextProvider } from '@/contexts/item-lead-time-context';
import { LeadGeneratorScreen } from '@/screens/locations/lead-generator-screen';
import { LOCATION_MANAGER_ROUTES } from './routes';
import { LocationManagerStackParams } from './types';
import { LocationPickerDuplicateScreen } from '@/screens/locations/location-picker-duplicate-screen';
import { LocationPickerScreen } from '@/screens/locations/location-picker-screen';
import { MenuCameraScreen } from '@/screens/locations/menu-camera-screen';
import { RestaurantEmployeesScreen } from '@/screens/restaurant/restaurant-employees-screen';
import { RestaurantInviteEmployeeScreen } from '@/screens/restaurant/restaurant-invite-employee-screen';
import { useDefaultStackScreenOptions } from '@/hooks/use-default-stack-screen-options';
import { ViewAccountMenuScreen } from '@/screens/locations/view-account-menu';
import { ViewAccountScreen } from '@/screens/locations/view-account-screen';
import { ViewImageGeneratedMenuScreen } from '@/screens/locations/view-image-generated-menu';
import { VolumePromotionsContextProvider } from '@/contexts/volume-promotions-context';

const Stack = createStackNavigator<LocationManagerStackParams>();

export const LocationManagerStack: React.FC = () => {
  const options = useDefaultStackScreenOptions();
  return (
    <ItemLeadTimeContextProvider>
      <VolumePromotionsContextProvider>
        <AdsContextProvider>
          <Stack.Navigator screenOptions={options}>
            <Stack.Screen
              component={LocationPickerScreen}
              name={LOCATION_MANAGER_ROUTES.Base}
            />
            <Stack.Screen
              component={LocationPickerDuplicateScreen}
              name={LOCATION_MANAGER_ROUTES.DuplicateOrder}
            />
            <Stack.Screen
              component={CreateAccountScreen}
              name={LOCATION_MANAGER_ROUTES.CreateAccount}
            />
            <Stack.Screen
              component={EditAccountScreen}
              name={LOCATION_MANAGER_ROUTES.EditAccount}
            />
            <Stack.Screen
              component={LeadGeneratorScreen}
              name={LOCATION_MANAGER_ROUTES.LeadGenerator}
            />
            <Stack.Screen
              component={MenuCameraScreen}
              name={LOCATION_MANAGER_ROUTES.MenuCamera}
            />
            <Stack.Screen
              component={RestaurantInviteEmployeeScreen}
              name={LOCATION_MANAGER_ROUTES.InviteEmployee}
            />
            <Stack.Screen
              component={RestaurantEmployeesScreen}
              name={LOCATION_MANAGER_ROUTES.ViewAccountEmployees}
            />
            <Stack.Screen
              component={EmployeeDetailScreen}
              name={LOCATION_MANAGER_ROUTES.ViewEmployeeDetail}
            />
            <Stack.Screen
              component={EmployeeNotificationsScreen}
              name={LOCATION_MANAGER_ROUTES.ViewEmployeeNotifications}
            />
            <Stack.Screen
              component={ViewAccountScreen}
              name={LOCATION_MANAGER_ROUTES.ViewAccount}
            />
            <Stack.Screen
              component={ViewAccountMenuScreen}
              name={LOCATION_MANAGER_ROUTES.ViewAccountMenu}
            />
            <Stack.Screen
              component={ViewImageGeneratedMenuScreen}
              name={LOCATION_MANAGER_ROUTES.ViewImageGeneratedMenu}
            />
          </Stack.Navigator>
        </AdsContextProvider>
      </VolumePromotionsContextProvider>
    </ItemLeadTimeContextProvider>
  );
};
